import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { PagosProvider } from "./state/PagosContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <PagosProvider>
      <App />
    </PagosProvider>
  </React.StrictMode>
);
